import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    marginTop: 'auto',
    padding: theme.spacing(4, 2),
    borderTop: `solid 1px ${fade(theme.palette.primary.main, 0.2)}`,
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: theme.spacing(4, 0),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: '5rem',
    },
  },
  links: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '1rem 3rem',
    [theme.breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      gap: '3rem',
    },
  },
  link: {
    flexShrink: 0,
    flexBasis: theme.spacing(24),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
    color: theme.palette.primary.dark,
    [theme.breakpoints.up('sm')]: {
      flexBasis: 'auto',
    },
  },
  linkIcon: {
    flexShrink: 0,
    marginRight: theme.spacing(1),
  },
}))

export default useStyles
